export class SaasAppCost {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "storedBytes",
            "baseName": "storedBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "allowanceBytes",
            "baseName": "allowanceBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "commitmentWindows",
            "baseName": "commitmentWindows",
            "type": "Array<SaasCommitmentWindowCost>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasAppCost.attributeTypeMap;
    }
    constructor() {
    }
}
